import * as React from "react";
import { Link } from "react-router-dom";
import type { NormalizedCastMember } from "./castUtils.ts";

export type MediaCastSectionProps = {
  cast: NormalizedCastMember[];
};

const MediaCastSection: React.FC<MediaCastSectionProps> = ({ cast }) => {
  if (!cast.length) {
    return null;
  }

  return (
    <div className="media-cast-section">
      <h3 className="media-cast-heading">Cast</h3>
      <div className="media-cast-scroller" role="list">
        {cast.map((person) => {
          const src =
            person.profilePath && String(person.profilePath).length > 0
              ? `https://image.tmdb.org/t/p/w185${person.profilePath}`
              : "/images/no-image.jpg";
          return (
            <article key={person.id} className="media-cast-card" role="listitem">
              <Link to={`/person/${person.id}`} className="media-cast-card-link">
                <div className="media-cast-photo-wrap">
                  <img
                    src={src}
                    alt={person.name}
                    className="media-cast-photo"
                    decoding="async"
                  />
                </div>
                <div className="media-cast-meta">
                  <span className="media-cast-name">{person.name}</span>
                  <span className="media-cast-character">{person.character}</span>
                </div>
              </Link>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default MediaCastSection;
